import { Box } from '@mui/material'
import { useCallback } from 'react'
import { useStyles } from './styles'

interface IKanbanCardStatus {
  status: 'movimentation' | 'implantation' | 'quotation'
}

const KanbanCardStatus = ({ status }: IKanbanCardStatus) => {
  const classes = useStyles()

  const changeStyleByStatus = useCallback(
    (status: IKanbanCardStatus['status']) => {
      switch (status) {
        case 'implantation':
          return classes.containerImplantation
        case 'movimentation':
          return classes.containerMovimentation
        case 'quotation':
          return classes.containerQuotation
        default:
          break
      }
    },
    [status]
  )

  const changeStatusName = useCallback(
    (status: IKanbanCardStatus['status']) => {
      switch (status) {
        case 'implantation':
          return 'Implantação'
        case 'movimentation':
          return 'Movimentação'
        case 'quotation':
          return 'Cotação'
        default:
          break
      }
    },
    [status]
  )

  return (
    <Box className={changeStyleByStatus(status)}>
      <span className={classes.status}>{changeStatusName(status)}</span>
    </Box>
  )
}

export default KanbanCardStatus
